import React from 'react';
import { BridgePage } from './pages/BridgePage';
export function App() {
  return <BridgePage data-id="element-0" />;
}